import { BasketItemModel } from 'models/Basket';
import { BasketErrorModel, DEFAULT_ERROR_TEXT } from 'models/Errors';
import { externalScriptHelper, logsHelper, errorToBasketErrorModel } from 'helpers';
import { appConfig } from 'configurations';

export class OlapicRepository {
    public async purchase(entries: BasketItemModel[], basketId: string): Promise<void> {
        try {
            const olapic = await this.getOlapic();

            olapic.init(appConfig.olapicKey);

            entries.map((entry: BasketItemModel) => {
                for (let index = 0; index < entry.quantity; index++) {
                    olapic.addProduct(entry.product.code, entry.totalPrice.value / entry.quantity);
                }
            });

            olapic.addAttribute('transactionId', basketId);
            olapic.addAttribute('currencyCode', 'GBP');

            olapic.execute();
        } catch (error) {
            logsHelper.error(errorToBasketErrorModel(error, 'olapic.repository:purchase'));
        }
    }

    private async getOlapic(): Promise<Olapic> {
        const olapic: Olapic | null = await externalScriptHelper.getExternalScriptWithTimeout<Olapic>('olapicCheckout');
        if (!olapic) {
            throw new BasketErrorModel(DEFAULT_ERROR_TEXT, 'Olapic object does not exist in window', 'olapic.repository:sendMessage');
        }

        return olapic;
    }
}

interface Olapic {
    init: (olapicKey: string) => void;
    addProduct: (code: string, price: number) => void;
    addAttribute: (key: string, value: string) => void;
    execute: () => void;
}

export const olapic = new OlapicRepository();